import { buildQueryString } from '../../lib/api-client';
import type { OfferDetails } from '../../lib/types';

const _cache = new Map<string, OfferDetails>();

export function get(id: string): OfferDetails | undefined {
    return _cache.get(id);
}

export function has(id: string): boolean {
    return _cache.has(id);
}

export function clear(): void {
    _cache.clear();
}

export function getAll(): Record<string, OfferDetails> {
    return Object.fromEntries(_cache);
}

/** Fetch offer details for IDs not yet in cache, then store them. */
export async function load(ids: string[], url: string, agencyId: string): Promise<void> {
    const missing = ids.filter(id => !_cache.has(id));
    if (missing.length === 0) return;

    const qs = buildQueryString({ offerIds: missing, agencyId });
    const resp = await fetch(`${url}?${qs}`);
    if (!resp.ok) throw new Error(`offer-cache: HTTP ${resp.status}`);
    const data: OfferDetails[] = await resp.json();
    for (const offer of data) _cache.set(offer.id, offer);
}
